import {
  Box,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import ActivityIcons from './activityIcons'
import { ArrowDropDown, ArrowDropUp, Info } from '@mui/icons-material'
import { grey } from '@mui/material/colors'

const LinearProgressWithLabel = (props) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress
          variant='determinate'
          {...props}
          value={Math.min(100, props.value)}
          color={props.value >= 100 ? 'success' : 'primary'}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant='body2' color='text.secondary'>{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  )
}

const ActivityKPITable = ({
  activityTypes,
  activities,
  condensedGoals,
  allActivitiesByIdentityIds,
  goalsByIdentity,
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
              KPI{' '}
              <Tooltip
                sx={{ ml: 2 }}
                title={
                  <Typography sx={{ fontSize: '18px' }}>
                    This KPI Tracking data comes from "Actions & Opportunities"
                    that are completed in the "Account Profile" screen.
                  </Typography>
                }
              >
                <Info color='primary'></Info>
              </Tooltip>
            </TableCell>
            <TableCell>Goal</TableCell>
            <TableCell>MTD Actual</TableCell>
            <TableCell>MTD %</TableCell>
            <TableCell>YTD %</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {activityTypes.map((at) => {
            return (
              <Row
                key={at.id}
                at={at}
                activities={activities}
                condensedGoals={condensedGoals}
                goalsByIdentity={goalsByIdentity}
                allActivitiesByIdentityIds={allActivitiesByIdentityIds}
              ></Row>
            )
          })}
        </TableBody>
      </Table>
    </>
  )
}

const Row = ({
  at,
  activities,
  condensedGoals,
  allActivitiesByIdentityIds,
  goalsByIdentity,
}) => {
  const Icon = ActivityIcons[at.id]

  const activity = activities.find((a) => a.activityTypeId === at.id)
  const count = activity?.count || 0

  const goal = condensedGoals.find((g) => g.activityTypeId === at.id)

  const mtdPercentage = Math.min(
    (Number(count) / Number(goal?.goal || 1)) * 100,
    100
  )

  const ytdPercentage = Math.min(
    (Number(count) / (goal?.goal ? Number(goal.goal) * 12 : 1)) * 100,
    100
  )

  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <TableRow key={at.id} sx={{ backgroundColor: 'white' }}>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {!!Icon && <Icon color={'primary'} sx={{ mr: 1 }} />}
            {at.name}
          </Box>
        </TableCell>
        <TableCell>{goal?.goal}</TableCell>
        <TableCell>
          {at.id === 6 && '$'}
          {at.id === 6 ? Number(count || 0).toFixed(2) : count}
        </TableCell>
        <TableCell sx={{ minWidth: '100px' }}>
          {goal && <LinearProgressWithLabel value={mtdPercentage} />}
        </TableCell>
        <TableCell sx={{ minWidth: '100px' }}>
          {goal && <LinearProgressWithLabel value={ytdPercentage} />}
        </TableCell>
        <TableCell>
          <IconButton
            onClick={() => {
              setExpanded(!expanded)
            }}
          >
            <ArrowDropDown
              sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'all 0.3s',
              }}
            />
          </IconButton>
        </TableCell>
      </TableRow>
      {expanded &&
        allActivitiesByIdentityIds.map((identity) => {
          const activity = identity.activities.find(
            (a) => a.activityTypeId === at.id
          )

          const goalInd = goalsByIdentity
            .find((g) => g.id === identity.identityId)
            ?.goals?.find((g) => g.activityTypeId === at.id)?.goal

          const mtdPercentageInd = Math.min(
            (Number(activity?.count || 0) / Number(goalInd || 1)) * 100,
            100
          )

          const ytdPercentageInd = Math.min(
            (Number(activity?.count || 0) /
              (goalInd ? Number(goalInd) * 12 : 1)) *
              100,
            100
          )

          return (
            <TableRow
              key={'id' + identity.identityId}
              sx={{ backgroundColor: grey[100] }}
            >
              <TableCell>{identity.name}</TableCell>
              <TableCell>{goalInd || 0}</TableCell>
              <TableCell>
                {at.id === 6 && '$'}
                {activity?.count || 0}
              </TableCell>
              <TableCell sx={{ minWidth: '100px' }}>
                {goal && <LinearProgressWithLabel value={mtdPercentageInd} />}
              </TableCell>
              <TableCell sx={{ minWidth: '100px' }}>
                {goal && <LinearProgressWithLabel value={ytdPercentageInd} />}
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          )
        })}
    </>
  )
}

export default ActivityKPITable
